var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    _vm._l(_vm.lines, function(line, index) {
      return _c(
        "v-flex",
        { key: index },
        [
          _c("v-chip", { attrs: { color: line.left.characterColor } }, [
            _vm._v(_vm._s(line.left.characterName))
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(" to ")]),
          _vm._v(" "),
          _c("v-chip", { attrs: { color: line.right.characterColor } }, [
            _vm._v(_vm._s(line.right.characterName))
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(": " + _vm._s(line.msg))])
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-18df2812", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18df2812","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/conversation/chatArea.vue
// module id = null
// module chunks = 